import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import {
  collection,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const nombres = ["ivan", "cristian", "pablo", "franco"];

const Listado = () => {
  const [puesto, setPuesto] = useState("");
  const [puesto2, setPuesto2] = useState("");
  const [numero, setNumero] = useState(0);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [items, setItems] = useState([]);
  const [editandoId, setEditandoId] = useState(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "Plantel"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setItems(data);
    });
    return () => unsubscribe();
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!nombre) return;

  const numeroNormalizado = numero.trim().toUpperCase();

  // Buscar si ya existe ese número
  const existeNumero = items.find(
    (item) => item.numero === numeroNormalizado && item.id !== editandoId
  );

  if (existeNumero) {
    alert("Ya existe un jugador con ese número.");
    return;
  }

  const jugadorData = {
    numero: numeroNormalizado,
    puesto,
    nombre,
    puesto2,
    descripcion,
    fecha: new Date(),
  };

  if (editandoId) {
    const itemRef = doc(db, "Plantel", editandoId);
    await updateDoc(itemRef, jugadorData);
    setEditandoId(null);
  } else {
    await addDoc(collection(db, "Plantel"), jugadorData);
  }

  // Limpiar campos
  setNumero("");
  setPuesto("");
  setNombre("");
  setPuesto2("");
  setDescripcion("");
};


  const handleDelete = async (id) => {
    const itemRef = doc(db, "Plantel", id);
    await deleteDoc(itemRef);
  };

  const handleEdit = (item) => {
    setNumero(item.numero);
    setPuesto(item.puesto);
    setNombre(item.nombre);
    setDescripcion(item.descripcion);
    setPuesto2(item.puesto2);
    setEditandoId(item.id);
  };

  const handleRadioChange = async (id, nombreCampo, valor) => {
    const itemRef = doc(db, "Plantel", id);
    await updateDoc(itemRef, {
      [nombreCampo]: valor,
    });
  };

  return (
    <>
      <div style={{ padding: 20, marginLeft: 80 ,  marginTop: 10}} className="formulario-plantel">
       
        <form onSubmit={handleSubmit} >
           <h2 style={{ padding: 20, color: 'white', fontWeight: 600 }}>{editandoId ? "Editar Dato" : "Cargar Jugador"}</h2>
          <FormControl  style={{  width: "10vh" }}>
            <InputLabel id="posicion-label">Posición</InputLabel>
            <Select
              labelId="posicion-label"
              value={puesto}
              label="Posición"
              onChange={(e) => setPuesto(e.target.value)}
              required
              style={{ height: 45, background: 'white'}}
            >
              <MenuItem value="ARQ">ARQ</MenuItem>
              <MenuItem value="LI">LI</MenuItem>
              <MenuItem value="LD">LD</MenuItem>
              <MenuItem value="DF">DF</MenuItem>
              <MenuItem value="VI">VI</MenuItem>
              <MenuItem value="VD">VD</MenuItem>
              <MenuItem value="MC">MC</MenuItem>
              <MenuItem value="DC">DC</MenuItem>
            </Select>
          </FormControl>
          <br />
          <p style={{ margin: 0, fontWeight: 500 , color: 'white'}}>Numero</p>
          <input
            style={{ textTransform: "uppercase" }}
            value={numero}
            type="number"
            onChange={(e) => setNumero(e.target.value.toUpperCase())}
            placeholder="Número"
            required
          />
          <br />
          <p style={{ margin: 0, fontWeight: 500, color: 'white'}}>Nombre</p>
          <input
            style={{ textTransform: "uppercase" }}
            value={nombre}
            onChange={(e) => setNombre(e.target.value.toUpperCase())}
            placeholder="Nombre"
            required
          />
          <br />
          <p style={{margin: 0, fontWeight: 500, color: 'white'}}>Variante</p>
           <FormControl  style={{ margin: 0, width: "10vh" }}>
            <InputLabel id="posicion-label" style={{ color: 'gray'}}>otra Posición</InputLabel>
            <Select
              labelId="posicion-label"
              value={puesto2}
              label="Posición"
              onChange={(e) => setPuesto2(e.target.value)}
              style={{ height: 45, background: 'white'}}
            >
                <MenuItem value="ARQ">ARQ</MenuItem>
              <MenuItem value="LI">LI</MenuItem>
              <MenuItem value="LD">LD</MenuItem>
              <MenuItem value="DF">DF</MenuItem>
              <MenuItem value="VI">VI</MenuItem>
              <MenuItem value="VD">VD</MenuItem>
              <MenuItem value="MC">MC</MenuItem>
              <MenuItem value="DC">DC</MenuItem>
            </Select>
          </FormControl>
         
          <br />
          <p style={{ margin: 0, fontWeight: 500, color: 'white'}}>Anotaciones</p>
          <textarea
            style={{ textTransform: "uppercase" }}
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value.toUpperCase())}
            placeholder="Comentarios"
          />
          <br />
          <button type="submit" className={editandoId ? 'btn btn-info' : 'btn btn-success'}>{editandoId ? "Actualizar" : "Guardar"}</button>
        </form>
      <div>
      <h3 style={{ color: 'white', fontWeight: 600}}>Listado:</h3>
        <ul className="item-listado">
          {items.map((item) => (
            <li key={item.id} style={{ color: 'white', textDecoration: 'none'}}>
              <strong>{item.nombre}</strong>:  {item.numero} {item.puesto}  {item.puesto2} {" "}
              {item.descripcion}
             <imput onClick={() => handleEdit(item)} style={{ marginLeft: 10 }}>
              <EditIcon sx={{ color: 'black' }}/>
              </imput>
           <imput onClick={() => handleDelete(item.id)} style={{ marginLeft: 5 , color: 'red'}}>
            <DeleteIcon />
            </imput>
            </li>
          ))}
        </ul>
        </div>
        
      </div>

      <TableContainer component={Paper} style={{ width: "100vh", maxWidth: 1000, margin: "3px" }}>
        <Table className="tabla">
          <TableHead className="t-head">
            <TableRow className="col-datos"> 
              <TableCell style={{ width: "1vh", color: 'white' }}>Posición</TableCell>
              <TableCell style={{ width: "1vh", color: 'white'  }}>Número</TableCell>
              <TableCell style={{ width: "2vh", color: 'white'  }}>Jugador</TableCell>
              {nombres.map((nombre) => (
                <TableCell key={nombre} style={{ width: "2vh", color: 'white'  }} >
                  {nombre.charAt(0).toUpperCase() + nombre.slice(1)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
           {items.map((fila) => {
  const respuestas = [fila.ivan, fila.cristian, fila.pablo, fila.franco];
  const cantidadSi = respuestas.filter((r) => r === "si").length;
  const cantidadNo = respuestas.filter((r) => r === "no").length;
   const cantidadAm = respuestas.filter((r) => r === "duda").length;
  const fondoVerde = cantidadSi >= 3; // o >=2 si querés mayoría simple
  const fondoRojo = cantidadNo >= 3; // o >=2 si querés mayoría simple
  const fondoAmarillo= cantidadAm >= 3; // o >=2 si querés mayoría simple

  return (
    <TableRow
      key={fila.id}
      style={{
        backgroundColor: fondoVerde ? "#d0f5d0" : "inherit" && fondoRojo ? "#ffb4a5" : "inherit" && fondoAmarillo ? "#FFFF00" : "inherit", // verde claro si tiene mayoría de 'si'
      }}
    >
      <TableCell >{fila.puesto}</TableCell>
      <TableCell>{fila.numero}</TableCell>
      <TableCell>{fila.nombre}</TableCell>

      {nombres.map((nombre) => (
        <TableCell key={nombre}>
          <RadioGroup
            row
            value={fila[nombre] || ""}
            onChange={(e) => handleRadioChange(fila.id, nombre, e.target.value)}
          >
            <FormControlLabel value="si" control={<Radio />} label="✓" style={{ color: "green" }} />
            <FormControlLabel value="no" control={<Radio />} label="✗" style={{ color: "red" }} />
            <FormControlLabel value="duda" control={<Radio />} label="O" style={{ color: "brown" }} />
          </RadioGroup>
        </TableCell>
      ))}
    </TableRow>
  );
})}
          </TableBody>
        </Table>
      </TableContainer>
      <hr/>
      
    </>
  );
};

export default Listado;
